import React from "react";

const socialList = [
  {
    name: "FB.",
    link: "https://www.facebook.com/some0ne1991",
  },
  {
    name: "LI.",
    link: "https://linkedin.com/in/przemyslawkasiura",
  },
  {
    name: "TW.",
    link: "https://twitter.com/p_kasiura",
  },
];

const SocialTwo = () => {
  return (
    <ul>
      {socialList.map((val, i) => (
        <li key={i}>
          <a href={val.link} target="_blank" rel="noreferrer">
            <span className="first">{val.name}</span>
            <span className="second">{val.name}</span>
          </a>
        </li>
      ))}
    </ul>
  );
};

export default SocialTwo;
